import StyleGuide from './StyleGuide';

export default StyleGuide;
